import React, { FC } from 'react';
import { LanguagePickerProps } from './LanguagePickerProps';
import globe from '@ingka/ssr-icon/paths/globe';
import Select, { Option } from '@ingka/select';

export const LANGUAGES = [
  {
    name: 'English',
    code: 'en',
  },
  {
    name: 'Español',
    code: 'es',
  },
  {
    name: 'Français',
    code: 'fr',
  },
  {
    name: 'Português',
    code: 'pt',
  },
  {
    name: 'Chinese',
    code: 'cn',
  },
];
const LanguagePicker: FC<LanguagePickerProps> = ({
  selectedLanguage,
  onLanguageChange,
}) => {
  return (
    <Select
      id={'language-selector'}
      ssrIcon={globe}
      label={null}
      value={selectedLanguage}
      onChange={onLanguageChange}
    >
      {LANGUAGES.map((lang) => (
        <Option key={lang.code} value={lang.code} name={lang.name} />
      ))}
    </Select>
  );
};

export default LanguagePicker;
